import { analyzeTender } from '../../services/tenderAnalysis';
import { notify } from '../../store/feedback';
import { extractPdfText } from '../../utils/pdfText';
import { analysisFromResult, scoreUpdateFrom } from '../../utils/tenderDocuments';
import { endUpload } from './uploadState';

/* Analyse IA des dossiers d'appels d'offres. */
export default function tenderAnalysisHandlers(deps) {
  const { session, setTenders, setTenderUploadBusy, setTenderUploadIdweb } = deps;
  const { setTenderUploadProgress, setTenderUploadStepText, setModalData } = deps;

  // Appelle boamp-analyze avec le jeton de session du manager et fusionne le résultat dans
  // modalData/aoNotices — partagé entre l'import (nouveaux documents) et une réanalyse à froid
  // (mêmes documents, ex. après une correction du prompt/profil de capacité).
  async function runTenderAnalysis(idweb) {
    setTenderUploadStepText("Analyse du dossier par l'IA…");
    setTenderUploadProgress(null); // durée non prévisible (jusqu'à 1-2 min sur plusieurs gros documents)
    const res = await analyzeTender(idweb, session.access_token);
    if (!res.ok) {
      const t = await res.text();
      notify('Erreur analyse : ' + t.slice(0, 300));
      return false;
    }
    const result = await res.json();
    const maj = {
      ...scoreUpdateFrom(result),
      boamp_document_analysis: analysisFromResult(result, new Date().toISOString()),
    };
    setModalData((d) => (d.notice ? { ...d, notice: { ...d.notice, ...maj } } : d));
    setTenders((list) => list.map((n) => (n.idweb === idweb ? { ...n, ...maj } : n)));
    setTenderUploadStepText('Analyse terminée');
    setTenderUploadProgress(1);
    return true;
  }

  // Réanalyse un AO dont les documents sont déjà importés, sans nouvel upload (ex. après une
  // correction du prompt ou du profil de capacité — voir motif d'écartement erroné du 2026-09-04).
  async function reanalyzeTender(idweb) {
    if (!session?.access_token) {
      notify('Session expirée, reconnectez-vous.');
      return;
    }
    setTenderUploadBusy(true);
    setTenderUploadIdweb(idweb);
    try {
      await runTenderAnalysis(idweb);
    } catch (e) {
      notify("Erreur inattendue à l'analyse : " + (e?.message || e));
    } finally {
      endUpload(deps);
    }
  }

  return { extractPdfText, runTenderAnalysis, reanalyzeTender };
}
